var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9321 3.51063L15.6921 7.03063C15.9321 7.52063 16.5721 7.99063 17.1121 8.08063L20.3021 8.61062C22.3421 8.95062 22.8221 10.4306 21.3521 11.8906L18.8721 14.3706C18.4521 14.7906 18.2221 15.6006 18.3521 16.1806L19.0621 19.2506C19.6221 21.6806 18.3321 22.6206 16.1821 21.3506L13.1921 19.5806C12.6521 19.2606 11.7621 19.2606 11.2121 19.5806L8.22206 21.3506C6.08206 22.6206 4.78206 21.6706 5.34206 19.2506L6.05206 16.1806C6.18206 15.6006 5.95206 14.7906 5.53206 14.3706L3.05206 11.8906C1.59206 10.4306 2.06206 8.95062 4.10206 8.61062L7.29206 8.08063C7.82206 7.99063 8.46206 7.52063 8.70206 7.03063L10.4621 3.51063C11.4221 1.60063 12.9821 1.60063 13.9321 3.51063Z",
    stroke: "#222F88",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star.573c204c.svg";
export { ForwardRef as ReactComponent };